/* Rod Armour Rebuy Smart Cart owner.
   Configuration is injected via window.RA_REBUY before this file loads. */
(function () {
  var config = window.RA_REBUY || {};
  var themeRoutes = window.theme && window.theme.routes ? window.theme.routes : {};
  var cartRoute = config.cartRoute || themeRoutes.cartPage || '/cart';
  var cartAddRoute = config.cartAddRoute || themeRoutes.cartAdd || '/cart/add.js';
  var cartUpdateRoute = config.cartUpdateRoute || cartRoute.replace(/\/?$/, '/update.js');
  var checkoutRoute = normalizeCheckoutRoute(config.checkoutRoute || '/checkout?skip_shop_pay=true');
  var rebuyScriptUrl = config.scriptUrl;
  var productTitleMapUrl = config.productTitleMapUrl;
  var isDesignMode = !!config.designMode;
  var rebuyLoaderPromise = null;
  var productTitleMapPromise = null;
  var productTitleMap = null;
  var cartAddFormsInFlight = new WeakSet();
  var localizationTimer = null;
  var localizedText = {
    en: { add: 'Add', cartTitle: 'Your Cart', checkout: 'Checkout', closeCart: 'Close cart', continueShopping: 'Continue Shopping', freeGiftRemainingTemplate: 'You are {{amount}} away from a free {{product}}!', freeShipping: 'Free Shipping', freeShippingRemainingTemplate: 'You are {{amount}} away from FREE SHIPPING!', itemPlural: 'items', itemSingular: 'item', size: 'Size', subtotal: 'Subtotal', youMayAlsoLike: 'You may also like' },
    fr: { add: 'Ajouter', cartTitle: 'Votre panier', checkout: 'Procéder au paiement', closeCart: 'Fermer le panier', continueShopping: 'Continuer vos achats', freeGiftRemainingTemplate: 'Plus que {{amount}} pour recevoir {{product}} gratuit !', freeShipping: 'Livraison gratuite', freeShippingRemainingTemplate: 'Plus que {{amount}} pour bénéficier de la livraison gratuite !', itemPlural: 'articles', itemSingular: 'article', size: 'Taille', subtotal: 'Sous-total', youMayAlsoLike: 'Vous aimerez aussi' },
    de: { add: 'Hinzufügen', cartTitle: 'Ihr Warenkorb', checkout: 'Zur Kasse', closeCart: 'Warenkorb schließen', continueShopping: 'Weiter einkaufen', freeGiftRemainingTemplate: 'Noch {{amount}} bis zu einem kostenlosen {{product}}!', freeShipping: 'Kostenloser Versand', freeShippingRemainingTemplate: 'Noch {{amount}} bis zum kostenlosen Versand!', itemPlural: 'Artikel', itemSingular: 'Artikel', size: 'Größe', subtotal: 'Zwischensumme', youMayAlsoLike: 'Das könnte Ihnen auch gefallen' },
    es: { add: 'Añadir', cartTitle: 'Tu carrito', checkout: 'Finalizar pedido', closeCart: 'Cerrar carrito', continueShopping: 'Seguir comprando', freeGiftRemainingTemplate: 'Te faltan {{amount}} para conseguir {{product}} gratis!', freeShipping: 'Envío gratis', freeShippingRemainingTemplate: 'Te faltan {{amount}} para conseguir envío gratis!', itemPlural: 'artículos', itemSingular: 'artículo', size: 'Tamaño', subtotal: 'Subtotal', youMayAlsoLike: 'También te puede gustar' },
    it: { add: 'Aggiungi', cartTitle: 'Il tuo carrello', checkout: 'Check-out', closeCart: 'Chiudi il carrello', continueShopping: 'Continua lo shopping', freeGiftRemainingTemplate: 'Ti mancano {{amount}} per ricevere {{product}} gratis!', freeShipping: 'Spedizione gratuita', freeShippingRemainingTemplate: 'Ti mancano {{amount}} per la spedizione gratuita!', itemPlural: 'articoli', itemSingular: 'articolo', size: 'Dimensioni', subtotal: 'Subtotale', youMayAlsoLike: 'Ti potrebbe piacere anche' },
    nl: { add: 'Toevoegen', cartTitle: 'Je winkelwagen', checkout: 'Afrekenen', closeCart: 'Winkelwagen sluiten', continueShopping: 'Verder winkelen', freeGiftRemainingTemplate: 'Nog {{amount}} tot een gratis {{product}}!', freeShipping: 'Gratis verzending', freeShippingRemainingTemplate: 'Nog {{amount}} tot gratis verzending!', itemPlural: 'artikelen', itemSingular: 'artikel', size: 'Maat', subtotal: 'Subtotaal', youMayAlsoLike: 'Misschien vind je dit ook leuk' },
    pt: { add: 'Adicionar', cartTitle: 'O seu carrinho', checkout: 'Finalizar compra', closeCart: 'Fechar carrinho', continueShopping: 'Continuar a comprar', freeGiftRemainingTemplate: 'Faltam {{amount}} para receber {{product}} grátis!', freeShipping: 'Envio gratuito', freeShippingRemainingTemplate: 'Faltam {{amount}} para envio gratuito!', itemPlural: 'artigos', itemSingular: 'artigo', size: 'Tamanho', subtotal: 'Subtotal', youMayAlsoLike: 'Também pode gostar' },
    pl: { add: 'Dodaj', cartTitle: 'Twój koszyk', checkout: 'Przejdź do kasy', closeCart: 'Zamknij koszyk', continueShopping: 'Kontynuuj zakupy', freeGiftRemainingTemplate: 'Brakuje {{amount}}, aby otrzymać {{product}} gratis!', freeShipping: 'Darmowa dostawa', freeShippingRemainingTemplate: 'Brakuje {{amount}} do darmowej dostawy!', itemPlural: 'produkty', itemSingular: 'produkt', size: 'Rozmiar', subtotal: 'Suma częściowa', youMayAlsoLike: 'Może Ci się też spodobać' },
    sv: { add: 'Lägg till', cartTitle: 'Din varukorg', checkout: 'Till kassan', closeCart: 'Stäng varukorgen', continueShopping: 'Fortsätt handla', freeGiftRemainingTemplate: 'Du är {{amount}} från en gratis {{product}}!', freeShipping: 'Fri frakt', freeShippingRemainingTemplate: 'Du är {{amount}} från fri frakt!', itemPlural: 'artiklar', itemSingular: 'artikel', size: 'Storlek', subtotal: 'Delsumma', youMayAlsoLike: 'Du kanske också gillar' },
    da: { add: 'Tilføj', cartTitle: 'Din kurv', checkout: 'Til kassen', closeCart: 'Luk kurv', continueShopping: 'Fortsæt med at handle', freeGiftRemainingTemplate: 'Du mangler {{amount}} for en gratis {{product}}!', freeShipping: 'Gratis fragt', freeShippingRemainingTemplate: 'Du mangler {{amount}} for gratis fragt!', itemPlural: 'varer', itemSingular: 'vare', size: 'Størrelse', subtotal: 'Subtotal', youMayAlsoLike: 'Du vil måske også kunne lide' },
    fi: { add: 'Lisää', cartTitle: 'Ostoskorisi', checkout: 'Siirry kassalle', closeCart: 'Sulje ostoskori', continueShopping: 'Jatka ostoksia', freeGiftRemainingTemplate: 'Olet {{amount}} päässä ilmaisesta tuotteesta {{product}}!', freeShipping: 'Ilmainen toimitus', freeShippingRemainingTemplate: 'Olet {{amount}} päässä ilmaisesta toimituksesta!', itemPlural: 'tuotetta', itemSingular: 'tuote', size: 'Koko', subtotal: 'Välisumma', youMayAlsoLike: 'Saatat pitää myös näistä' },
    nb: { add: 'Legg til', cartTitle: 'Handlekurven din', checkout: 'Til kassen', closeCart: 'Lukk handlekurv', continueShopping: 'Fortsett å handle', freeGiftRemainingTemplate: 'Du er {{amount}} unna en gratis {{product}}!', freeShipping: 'Gratis frakt', freeShippingRemainingTemplate: 'Du er {{amount}} unna gratis frakt!', itemPlural: 'varer', itemSingular: 'vare', size: 'Størrelse', subtotal: 'Delsum', youMayAlsoLike: 'Du liker kanskje også' },
    cs: { add: 'Přidat', cartTitle: 'Váš košík', checkout: 'Pokladna', closeCart: 'Zavřít košík', continueShopping: 'Pokračovat v nákupu', freeGiftRemainingTemplate: 'Chybí vám {{amount}} k bezplatnému produktu {{product}}!', freeShipping: 'Doprava zdarma', freeShippingRemainingTemplate: 'Chybí vám {{amount}} do dopravy zdarma!', itemPlural: 'položek', itemSingular: 'položka', size: 'Velikost', subtotal: 'Mezisoučet', youMayAlsoLike: 'Mohlo by se vám také líbit' },
    sk: { add: 'Pridať', cartTitle: 'Váš košík', checkout: 'Prejsť k pokladni', closeCart: 'Zavrieť košík', continueShopping: 'Pokračovať v nákupe', freeGiftRemainingTemplate: 'Chýba vám {{amount}} k bezplatnému produktu {{product}}!', freeShipping: 'Doprava zadarmo', freeShippingRemainingTemplate: 'Chýba vám {{amount}} do dopravy zadarmo!', itemPlural: 'položiek', itemSingular: 'položka', size: 'Veľkosť', subtotal: 'Medzisúčet', youMayAlsoLike: 'Mohlo by sa vám tiež páčiť' },
    hr: { add: 'Dodaj', cartTitle: 'Vaša košarica', checkout: 'Plaćanje', closeCart: 'Zatvori košaricu', continueShopping: 'Nastavite kupovati', freeGiftRemainingTemplate: 'Nedostaje vam {{amount}} do besplatnog proizvoda {{product}}!', freeShipping: 'Besplatna dostava', freeShippingRemainingTemplate: 'Nedostaje vam {{amount}} do besplatne dostave!', itemPlural: 'artikala', itemSingular: 'artikl', size: 'Veličina', subtotal: 'Međuzbroj', youMayAlsoLike: 'Možda će vam se također svidjeti' },
    hu: { add: 'Hozzáadás', cartTitle: 'Kosarad', checkout: 'Fizetés', closeCart: 'Kosár bezárása', continueShopping: 'Vásárlás folytatása', freeGiftRemainingTemplate: 'Már csak {{amount}} hiányzik az ingyenes {{product}} termékhez!', freeShipping: 'Ingyenes szállítás', freeShippingRemainingTemplate: 'Már csak {{amount}} hiányzik az ingyenes szállításhoz!', itemPlural: 'termék', itemSingular: 'termék', size: 'Méret', subtotal: 'Részösszeg', youMayAlsoLike: 'Ez is tetszhet' },
    ro: { add: 'Adaugă', cartTitle: 'Coșul tău', checkout: 'Finalizați comanda', closeCart: 'Închideți coșul', continueShopping: 'Continuați cumpărăturile', freeGiftRemainingTemplate: 'Mai aveți {{amount}} până la un {{product}} gratuit!', freeShipping: 'Transport gratuit', freeShippingRemainingTemplate: 'Mai aveți {{amount}} până la transport gratuit!', itemPlural: 'articole', itemSingular: 'articol', size: 'Mărime', subtotal: 'Subtotal', youMayAlsoLike: 'S-ar putea să vă placă și' },
    bg: { add: 'Добави', cartTitle: 'Вашата количка', checkout: 'Към касата', closeCart: 'Затвори количката', continueShopping: 'Продължете с пазаруването', freeGiftRemainingTemplate: 'Остават {{amount}} до безплатен {{product}}!', freeShipping: 'Безплатна доставка', freeShippingRemainingTemplate: 'Остават {{amount}} до безплатна доставка!', itemPlural: 'артикула', itemSingular: 'артикул', size: 'Размер', subtotal: 'Междинна сума', youMayAlsoLike: 'Може също да харесате' },
    el: { add: 'Προσθήκη', cartTitle: 'Το καλάθι σας', checkout: 'Ολοκλήρωση αγοράς', closeCart: 'Κλείσιμο καλαθιού', continueShopping: 'Συνέχεια αγορών', freeGiftRemainingTemplate: 'Σας απομένουν {{amount}} για δωρεάν {{product}}!', freeShipping: 'Δωρεάν αποστολή', freeShippingRemainingTemplate: 'Σας απομένουν {{amount}} για δωρεάν αποστολή!', itemPlural: 'είδη', itemSingular: 'είδος', size: 'Μέγεθος', subtotal: 'Μερικό σύνολο', youMayAlsoLike: 'Μπορεί επίσης να σας αρέσει' },
    uk: { add: 'Додати', cartTitle: 'Ваш кошик', checkout: 'Оформити замовлення', closeCart: 'Закрити кошик', continueShopping: 'Продовжити покупки', freeGiftRemainingTemplate: 'Залишилось {{amount}} до безкоштовного {{product}}!', freeShipping: 'Безкоштовна доставка', freeShippingRemainingTemplate: 'Залишилось {{amount}} до безкоштовної доставки!', itemPlural: 'товари', itemSingular: 'товар', size: 'Розмір', subtotal: 'Проміжний підсумок', youMayAlsoLike: 'Вам також може сподобатися' }
  };

  Object.keys(localizedText).forEach(function (key) {
    var dictionary = localizedText[key];
    dictionary.freeShippingRemaining = function (amount) {
      return this.freeShippingRemainingTemplate.replace('{{amount}}', amount);
    };
    dictionary.freeGiftRemaining = function (amount, product) {
      return this.freeGiftRemainingTemplate.replace('{{amount}}', amount).replace('{{product}}', product);
    };
  });

  if (!rebuyScriptUrl) {
    return;
  }

  function isCartPage() {
    return document.body.classList.contains('template-cart') || window.location.pathname === cartRoute;
  }

  function isLocalThemePreview() {
    return window.location.hostname === '127.0.0.1' || window.location.hostname === 'localhost';
  }

  function fallbackToCartPage(error) {
    if (error && isDesignMode) {
      console.warn('Rebuy Smart Cart unavailable; falling back to cart page:', error);
    }
    if (!isCartPage()) {
      window.location.assign(cartRoute);
    }
  }

  function normalizeCheckoutRoute(route) {
    var normalized = String(route || '/checkout?skip_shop_pay=true');
    normalized = normalized.replace(/^\/([a-z]{2}(?:-[a-z]{2})?)checkout(?=\/|\?|#|$)/i, '/$1/checkout');
    return normalized;
  }

  function getDirectCheckoutPath() {
    try {
      var url = new URL(checkoutRoute || '/checkout', window.location.origin);
      url.searchParams.set('skip_shop_pay', 'true');
      return url.pathname + url.search + url.hash;
    } catch (error) {
      return '/checkout?skip_shop_pay=true';
    }
  }

  function applyDirectCheckoutRouting(RebuyInstance) {
    var smartCart = RebuyInstance && RebuyInstance.SmartCart;
    if (!smartCart || typeof smartCart.getCheckoutSettings !== 'function') {
      return RebuyInstance;
    }

    try {
      var settings = smartCart.getCheckoutSettings();
      var checkoutButton = settings && (settings.checkout_button || settings.checkoutButton);
      if (checkoutButton) {
        checkoutButton.routing = 'custom';
        checkoutButton.routing_link = getDirectCheckoutPath();
        checkoutButton.routingLink = getDirectCheckoutPath();
      }
    } catch (error) {
      if (isDesignMode) console.warn('Could not apply direct checkout routing to Rebuy:', error);
    }

    return RebuyInstance;
  }

  function applyRebuyRuntimeConfig(RebuyInstance) {
    applyFreeShippingThreshold(RebuyInstance);
    return applyDirectCheckoutRouting(RebuyInstance);
  }

  function applyGlobalRebuyRuntimeConfig() {
    if (window.Rebuy) {
      applyRebuyRuntimeConfig(window.Rebuy);
    }
  }

  function waitForRebuySmartCart(resolve, reject) {
    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;
      if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.show === 'function') {
        window.clearInterval(timer);
        resolve(window.Rebuy);
        return;
      }
      if (attempts > 80) {
        window.clearInterval(timer);
        reject(new Error('Rebuy Smart Cart did not become ready in time.'));
      }
    }, 100);
  }

  function applyFreeShippingThreshold(RebuyInstance) {
    if (config.freeShippingThreshold == null) return RebuyInstance;
    try {
      var smartCart = RebuyInstance && RebuyInstance.SmartCart;
      if (smartCart && smartCart.config) {
        smartCart.config.free_shipping = {
          enabled: true,
          threshold: Number(config.freeShippingThreshold),
          currency: config.freeShippingCurrency || 'USD'
        };
      }
      if (window.Rebuy && window.Rebuy.config) {
        window.Rebuy.config.free_shipping_threshold = Number(config.freeShippingThreshold);
        window.Rebuy.config.free_shipping_currency = config.freeShippingCurrency || 'USD';
      }
    } catch (e) {
      if (isDesignMode) console.warn('Could not apply free-shipping threshold to Rebuy:', e);
    }
    return RebuyInstance;
  }

  function resolveLocaleKey(locale) {
    if (!locale) return 'en';
    var normalized = String(locale).trim().replace('_', '-').toLowerCase();
    var base = normalized.split('-')[0];
    return localizedText[normalized] ? normalized : (localizedText[base] ? base : 'en');
  }

  function getRouteLocaleKey() {
    var match = window.location.pathname.match(/^\/([a-z]{2})(?:-[a-z]{2})?(?:\/|$)/i);
    return match ? resolveLocaleKey(match[1]) : null;
  }

  function getLocaleKey() {
    var locale = (window.Shopify && window.Shopify.locale) ||
      document.documentElement.getAttribute('lang') ||
      '';
    return getRouteLocaleKey() || resolveLocaleKey(locale);
  }

  function getRoutePrefix() {
    var match = window.location.pathname.match(/^\/([a-z]{2}(?:-[a-z]{2})?)(?:\/|$)/i);
    return match ? '/' + match[1].toLowerCase() : '';
  }

  function setElementText(element, value) {
    if (!element || !value) return;
    element.textContent = value;
  }

  function loadProductTitleMap() {
    if (productTitleMap) return Promise.resolve(productTitleMap);
    if (!productTitleMapUrl || typeof window.fetch !== 'function') return Promise.resolve(null);
    if (productTitleMapPromise) return productTitleMapPromise;

    productTitleMapPromise = window.fetch(productTitleMapUrl, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Rebuy product title map failed to load.');
        return response.json();
      })
      .then(function (payload) {
        productTitleMap = payload && payload.titles ? payload.titles : payload;
        return productTitleMap;
      })
      .catch(function (error) {
        productTitleMapPromise = null;
        if (isDesignMode) console.warn('Rebuy product title map unavailable:', error);
        return null;
      });

    return productTitleMapPromise;
  }

  function handleFromProductPath(pathname) {
    var match = (pathname || '').match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function handleFromRebuyBlock(block, titleMap) {
    if (!block || !titleMap) return '';

    var classes = block.className ? String(block.className).split(/\s+/) : [];
    for (var i = 0; i < classes.length; i += 1) {
      var direct = classes[i];
      var stripped = direct.indexOf('product-') === 0 ? direct.slice(8) : direct;
      if (titleMap[stripped]) return stripped;
    }

    var link = block.querySelector('a[href*="/products/"]');
    if (!link) return '';
    try {
      return handleFromProductPath(new URL(link.href, window.location.origin).pathname);
    } catch (error) {
      return '';
    }
  }

  function localizeProductLinks(block, handle, title) {
    var routePrefix = getRoutePrefix();
    block.querySelectorAll('a[href*="/products/"]').forEach(function (link) {
      try {
        var url = new URL(link.href, window.location.origin);
        if (!handleFromProductPath(url.pathname)) return;
        url.host = window.location.host;
        url.protocol = window.location.protocol;
        url.pathname = routePrefix + '/products/' + handle;
        link.href = url.toString();
        link.setAttribute('aria-label', title);
      } catch (error) {
        return;
      }
    });

    block.querySelectorAll('img').forEach(function (image) {
      image.alt = title;
    });
  }

  function applyProductTitleMap(root, titleMap) {
    if (!root || !titleMap) return;
    var localeKey = getLocaleKey();
    var baseLocale = resolveLocaleKey(localeKey);

    root.querySelectorAll('.rebuy-product-block, .rebuy-cart__flyout-item').forEach(function (block) {
      var handle = handleFromRebuyBlock(block, titleMap);
      var titles = handle ? titleMap[handle] : null;
      if (!titles) return;

      var title = titles[localeKey] || titles[baseLocale] || titles.en;
      if (!title) return;

      block.querySelectorAll('.rebuy-product-title, .rebuy-product-title-link, .rebuy-cart__flyout-item-product-title').forEach(function (titleNode) {
        if (!titleNode) return;
        if (titleNode.querySelector && titleNode.querySelector('a[href*="/products/"], .rebuy-product-title-link')) return;
        titleNode.textContent = title;
        titleNode.setAttribute('data-ra-localized-product-title', 'true');
      });

      localizeProductLinks(block, handle, title);
    });
  }

  function localizeProductTitles(root) {
    loadProductTitleMap().then(function (titleMap) {
      applyProductTitleMap(root, titleMap);
      localizeAssistiveText(root, localizedText[getLocaleKey()]);
    });
  }

  function itemCountLabel(dictionary, count) {
    return Number(count) === 1 ? dictionary.itemSingular : dictionary.itemPlural;
  }

  function localizeLeafText(root, dictionary) {
    if (!root || !dictionary) return;
    root.querySelectorAll('h1, h2, h3, h4, p, span, button, a, div').forEach(function (element) {
      var text = (element.textContent || '').replace(/\s+/g, ' ').trim();
      if (!text) return;
      var replacement = null;
      var isProgressMessage = false;

      if (text === 'Your Cart') replacement = dictionary.cartTitle;
      if (text === 'Free Shipping') replacement = dictionary.freeShipping;
      if (text === 'You may also like') replacement = dictionary.youMayAlsoLike;
      if (text === 'Checkout') replacement = dictionary.checkout;
      if (text === 'Continue Shopping') replacement = dictionary.continueShopping;
      if (text === 'Add') replacement = dictionary.add;
      if (text === 'Size') replacement = dictionary.size;
      if (text === 'Subtotal') replacement = dictionary.subtotal;

      var subtotalWithCountMatch = text.match(/^Subtotal\s*\((\d+)\s+Items?\)$/i);
      if (subtotalWithCountMatch && dictionary.itemSingular && dictionary.itemPlural) {
        replacement = dictionary.subtotal + ' (' + subtotalWithCountMatch[1] + ' ' + itemCountLabel(dictionary, subtotalWithCountMatch[1]) + ')';
      }

      var itemCountMatch = text.match(/^\((\d+)\s+Items?\)$/i);
      if (itemCountMatch && dictionary.itemSingular && dictionary.itemPlural) {
        replacement = '(' + itemCountMatch[1] + ' ' + itemCountLabel(dictionary, itemCountMatch[1]) + ')';
      }

      var freeShippingMatch = text.match(/^You are (.+?) away from FREE SHIPPING!?$/i);
      if (freeShippingMatch && dictionary.freeShippingRemaining) {
        replacement = dictionary.freeShippingRemaining(freeShippingMatch[1]);
        isProgressMessage = true;
      }

      var freeGiftMatch = text.match(/^You are (.+?) away from a free (.+?)!?$/i);
      if (freeGiftMatch && dictionary.freeGiftRemaining) {
        replacement = dictionary.freeGiftRemaining(freeGiftMatch[1], freeGiftMatch[2]);
        isProgressMessage = true;
      }

      if (replacement && (element.children.length === 0 || (isProgressMessage && text.length < 180))) {
        setElementText(element, replacement);
      }
    });
  }

  function productTitleFromCartNode(element) {
    if (!element || !element.closest) return '';
    var item = element.closest('.rebuy-cart__flyout-item');
    if (!item) return '';
    var title = item.querySelector('.rebuy-cart__flyout-item-product-title, .rebuy-product-title, .rebuy-product-title-link');
    return title ? (title.textContent || '').replace(/\s+/g, ' ').trim() : '';
  }

  function localizeAssistiveText(root, dictionary) {
    if (!root || !dictionary) return;
    var language = config.language || {};
    var priceLabel = language.price || 'Price';
    var quantityLabel = language.quantity || 'Quantity';
    var subtotalLabel = language.subtotal || dictionary.subtotal || 'Subtotal';
    var reduceQuantityLabel = language.reduceQuantity || '';
    var increaseQuantityLabel = language.increaseQuantity || '';

    root.querySelectorAll('.sr-only').forEach(function (element) {
      var text = (element.textContent || '').replace(/\s+/g, ' ').trim();
      if (/^(Sale price|Original price|Price)$/i.test(text)) {
        setElementText(element, priceLabel);
        return;
      }
      if (/^Cart subtotal$/i.test(text)) {
        setElementText(element, subtotalLabel);
        return;
      }
      var progressMatch = text.match(/^Progress:\s*(.+)$/i);
      if (progressMatch) {
        setElementText(element, dictionary.freeShipping + ': ' + progressMatch[1]);
        return;
      }
      if (/^Quantity of\s+/i.test(text)) {
        var title = text.replace(/^Quantity of\s+/i, '').trim() || productTitleFromCartNode(element);
        setElementText(element, title ? quantityLabel + ' ' + title : quantityLabel);
      }
    });

    root.querySelectorAll('[aria-label]').forEach(function (element) {
      var label = element.getAttribute('aria-label') || '';
      var title = productTitleFromCartNode(element);
      if (/^Quantity of\s+/i.test(label)) {
        element.setAttribute('aria-label', title ? quantityLabel + ' ' + title : quantityLabel);
      }
      if (reduceQuantityLabel && /^Decrease quantity of\s+/i.test(label)) {
        element.setAttribute('aria-label', title ? reduceQuantityLabel + ': ' + title : reduceQuantityLabel);
      }
      if (increaseQuantityLabel && /^Increase quantity of\s+/i.test(label)) {
        element.setAttribute('aria-label', title ? increaseQuantityLabel + ': ' + title : increaseQuantityLabel);
      }
      if (/^Checkout$/i.test(label)) {
        element.setAttribute('aria-label', dictionary.checkout);
      }
    });

    var liveRegion = document.getElementById('rebuy-cart-live-region');
    if (liveRegion && /^Opening the cart\. There are/i.test((liveRegion.textContent || '').trim())) {
      liveRegion.textContent = dictionary.cartTitle;
    }
  }

  function localizeSmartCart() {
    var dictionary = localizedText[getLocaleKey()];
    var root = document.getElementById('rebuy-cart');
    if (!dictionary || !root) return;

    var title = root.querySelector('.rebuy-cart__title, #rebuy-cart-title, [data-rebuy-component="title-bar"]');
    var close = root.querySelector('.rebuy-cart__flyout-close, #rebuy-cart-close');
    localizeLeafText(root, dictionary);

    if (title && (title.textContent || '').replace(/\s+/g, ' ').trim() === 'Your Cart') {
      title.textContent = dictionary.cartTitle;
    }
    if (close) {
      close.setAttribute('aria-label', dictionary.closeCart);
      close.setAttribute('title', dictionary.closeCart);
      close.textContent = '×';
    }
    localizeProductTitles(root);
    localizeAssistiveText(root, dictionary);
  }

  function scheduleSmartCartLocalization() {
    window.clearTimeout(localizationTimer);
    localizationTimer = window.setTimeout(function () {
      localizeSmartCart();
      window.setTimeout(localizeSmartCart, 350);
      window.setTimeout(localizeSmartCart, 1200);
    }, 0);
  }

  function loadRebuy() {
    if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.show === 'function') {
      return Promise.resolve(applyRebuyRuntimeConfig(window.Rebuy));
    }
    if (rebuyLoaderPromise) {
      return rebuyLoaderPromise;
    }
    rebuyLoaderPromise = new Promise(function (resolve, reject) {
      var existing = document.querySelector('script[data-ra-rebuy-loader]');
      if (existing) {
        waitForRebuySmartCart(function (R) { resolve(applyRebuyRuntimeConfig(R)); }, reject);
        return;
      }
      var script = document.createElement('script');
      script.src = rebuyScriptUrl;
      script.async = true;
      script.setAttribute('data-ra-rebuy-loader', 'true');
      script.addEventListener('load', function () {
        waitForRebuySmartCart(function (R) { resolve(applyRebuyRuntimeConfig(R)); }, reject);
      }, { once: true });
      script.addEventListener('error', function () { reject(new Error('Failed to load Rebuy.')); }, { once: true });
      document.head.appendChild(script);
    }).catch(function (error) {
      rebuyLoaderPromise = null;
      throw error;
    });
    return rebuyLoaderPromise;
  }

  function hideNativeCartDrawer() {
    var drawer = document.getElementById('CartDrawer');
    if (drawer) {
      drawer.setAttribute('hidden', '');
      drawer.setAttribute('aria-hidden', 'true');
      drawer.classList.remove('drawer--is-open', 'is-transitioning');
    }
    if (document.body) {
      document.body.classList.remove('js-drawer-open-cart', 'drawer--is-open');
    }
    document.documentElement.classList.remove('js-drawer-open', 'js-drawer-open-cart', 'lock-scroll');
  }

  function normalizeCartTriggers() {
    document.querySelectorAll('.js-drawer-open-cart, [aria-controls="CartDrawer"], a[href="' + cartRoute + '"], a[href$="/cart"]').forEach(function (el) {
      if (el.getAttribute('href') === cartRoute || el.classList.contains('js-drawer-open-cart') || el.getAttribute('aria-controls') === 'CartDrawer') {
        el.classList.remove('js-drawer-open-cart');
        el.removeAttribute('aria-controls');
        el.setAttribute('data-ra-rebuy-cart-trigger', 'true');
      }
    });
    hideNativeCartDrawer();
  }

  function isRebuyCartVisible() {
    var rebuyCart = document.getElementById('rebuy-cart');
    var rebuyFlyout = document.querySelector('.rebuy-cart__flyout');
    var flyoutRect = rebuyFlyout ? rebuyFlyout.getBoundingClientRect() : null;
    var flyoutStyle = rebuyFlyout ? window.getComputedStyle(rebuyFlyout) : null;
    return !!(rebuyCart &&
      rebuyFlyout &&
      rebuyCart.classList.contains('is-visible') &&
      rebuyCart.getAttribute('aria-hidden') === 'false' &&
      flyoutStyle &&
      flyoutStyle.display !== 'none' &&
      flyoutStyle.visibility !== 'hidden' &&
      flyoutRect &&
      flyoutRect.width > 0 &&
      flyoutRect.height > 0 &&
      flyoutRect.right > 0 &&
      flyoutRect.left < window.innerWidth &&
      flyoutRect.bottom > 0 &&
      flyoutRect.top < window.innerHeight);
  }

  function showRebuyCartWhenReady(RebuyInstance) {
    var attempts = 0;
    var smartCart = RebuyInstance && RebuyInstance.SmartCart;
    return new Promise(function (resolve, reject) {
      (function showAndCheck() {
        hideNativeCartDrawer();
        if (smartCart && typeof smartCart.show === 'function') {
          smartCart.show();
        }
        if (isRebuyCartVisible()) {
          scheduleSmartCartLocalization();
          resolve();
          return;
        }
        attempts += 1;
        if (attempts > 80) {
          reject(new Error('Rebuy Smart Cart did not become visible in time.'));
          return;
        }
        window.setTimeout(showAndCheck, 100);
      })();
    });
  }

  function openRebuyCart() {
    if (isCartPage()) {
      return Promise.resolve();
    }
    normalizeCartTriggers();
    return loadRebuy()
      .then(showRebuyCartWhenReady)
      .catch(fallbackToCartPage);
  }

  function queueOpenRebuyCart() {
    window.clearTimeout(queueOpenRebuyCart.timer);
    queueOpenRebuyCart.timer = window.setTimeout(openRebuyCart, 0);
  }

  function stopCartEvent(event) {
    if (!event) return;
    if (typeof event.preventDefault === 'function') event.preventDefault();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
      return;
    }
    if (typeof event.stopPropagation === 'function') event.stopPropagation();
  }

  function isProductCartEvent(event) {
    var target = event && event.target;
    return !!(target && target.closest && (
      target.closest('.product-section') ||
      target.closest('product-form') ||
      target.closest('form[action*="/cart/add"]')
    ));
  }

  function getCartAddForm(target) {
    if (!target || !target.closest) {
      return null;
    }
    var form = target.closest('form');
    if (!form) {
      return null;
    }
    var action = form.getAttribute('action') || '';
    return action.indexOf('/cart/add') !== -1 ? form : null;
  }

  function getSubmitButton(form) {
    if (!form) {
      return null;
    }
    return form.querySelector('[type="submit"], .add-to-cart, .grid-product__atc-btn, .ra-best-match__atc');
  }

  function setCartAddLoading(form, isLoading) {
    var submitButton = getSubmitButton(form);
    if (!submitButton) {
      return;
    }
    submitButton.classList.toggle('btn--loading', isLoading);
    submitButton.classList.toggle('product-form__submit-button--pulsing', isLoading);
    submitButton.disabled = isLoading;
  }

  function parseCartAddResponse(response) {
    return response.text().then(function (text) {
      var data = null;
      if (text) {
        try {
          data = JSON.parse(text);
        } catch (error) {
          if (response.ok) {
            throw { description: 'Cart add returned an unreadable response. Please open the product page and try again.' };
          }
        }
      }
      if (!response.ok || (data && data.status === 422)) {
        if (isLocalThemePreview()) {
          throw { description: 'Shopify blocks cart adds on this local preview. Use the Shopify preview URL to test Add to Cart.' };
        }
        if (data) {
          throw data;
        }
        throw { description: 'Cart add failed. Please open the product page and try again.' };
      }
      if (!data) {
        throw { description: 'Cart add returned an empty response. Please open the product page and try again.' };
      }
      return data;
    });
  }

  function showCartAddError(form, error) {
    if (!form) {
      return;
    }
    var message = error && (error.description || error.message);
    if (!message) {
      message = 'Sorry, this item could not be added to cart.';
    }
    var existing = form.querySelector('.errors.ra-rebuy-cart-error');
    if (existing) {
      existing.remove();
    }
    var errorEl = document.createElement('div');
    errorEl.className = 'errors text-center ra-rebuy-cart-error';
    errorEl.textContent = typeof message === 'string' ? message : 'Sorry, this item could not be added to cart.';
    form.appendChild(errorEl);
  }

  function handleCartAddSubmit(event) {
    if (isCartPage()) {
      return;
    }
    var form = getCartAddForm(event.target);
    if (!form || form.hasAttribute('data-ra-native-cart-submit')) {
      return;
    }
    stopCartEvent(event);
    if (cartAddFormsInFlight.has(form)) {
      return;
    }
    cartAddFormsInFlight.add(form);
    setCartAddLoading(form, true);
    fetch(cartAddRoute, {
      method: 'POST',
      body: new FormData(form),
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(parseCartAddResponse)
      .then(function (product) {
        var submitButton = getSubmitButton(form);
        var eventDetail = {
          product: product,
          addToCartBtn: submitButton
        };
        form.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: eventDetail,
          bubbles: true
        }));
        queueOpenRebuyCart();
      })
      .catch(function (error) {
        showCartAddError(form, error);
      })
      .finally(function () {
        cartAddFormsInFlight.delete(form);
        setCartAddLoading(form, false);
      });
  }

  function handleProductFormCartNavigation(event) {
    if (!isProductCartEvent(event) || isCartPage()) return;
    stopCartEvent(event);
    queueOpenRebuyCart();
  }

  function handleCartTriggerClick(event) {
    var target = event.target;
    var trigger = target && target.closest && target.closest('[data-ra-rebuy-cart-trigger], .js-drawer-open-cart, [aria-controls="CartDrawer"], a[href="' + cartRoute + '"], a[href$="/cart"]');
    if (!trigger || isCartPage()) return;
    stopCartEvent(event);
    openRebuyCart();
  }

  function isCheckoutSubmit(event) {
    var submitter = event && event.submitter;
    if (!submitter && document.activeElement && document.activeElement.getAttribute) {
      submitter = document.activeElement;
    }
    return !!(submitter && submitter.getAttribute('name') === 'checkout');
  }

  function handleDirectCheckoutSubmit(event) {
    var form = event && event.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart"]') || !isCheckoutSubmit(event)) return;
    stopCartEvent(event);
    if (typeof window.fetch !== 'function') {
      window.location.assign(getDirectCheckoutPath());
      return;
    }
    window.fetch(cartUpdateRoute, {
      method: 'POST',
      body: new FormData(form),
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).finally(function () {
      window.location.assign(getDirectCheckoutPath());
    });
  }

  function init() {
    var currentUrl = new URL(window.location.href);
    if (currentUrl.searchParams.get('viewcart') === 'true' && currentUrl.pathname !== cartRoute) {
      currentUrl.searchParams.delete('viewcart');
      window.history.replaceState({}, document.title, currentUrl.toString());
      openRebuyCart();
    }

    normalizeCartTriggers();
    document.addEventListener('submit', handleDirectCheckoutSubmit, true);
    document.addEventListener('submit', handleCartAddSubmit, true);
    document.addEventListener('click', handleCartTriggerClick, true);
    document.addEventListener('product-form:cart:navigate', handleProductFormCartNavigation, true);
    document.addEventListener('product-form:submit:success', function (event) {
      if (!isProductCartEvent(event) || isCartPage()) return;
      queueOpenRebuyCart();
    }, true);
    document.addEventListener('product-form:cart:update', function (event) {
      if (!isProductCartEvent(event) || isCartPage()) return;
      queueOpenRebuyCart();
    }, true);
    document.addEventListener('ajaxProduct:added', function () {
      if (!isCartPage()) {
        queueOpenRebuyCart();
      }
    }, true);
    document.addEventListener('ra:cart:open', function (event) {
      if (isCartPage()) return;
      stopCartEvent(event);
      openRebuyCart();
    }, true);
    document.addEventListener('cart:open', function (event) {
      if (isCartPage()) return;
      stopCartEvent(event);
      openRebuyCart();
    }, true);
    document.addEventListener('rebuy:smartcart.show', function () {
      applyGlobalRebuyRuntimeConfig();
      scheduleSmartCartLocalization();
    });
    document.addEventListener('rebuy:cart.change', scheduleSmartCartLocalization);
    document.addEventListener('rebuy:smartcart.ready', function () {
      applyGlobalRebuyRuntimeConfig();
      scheduleSmartCartLocalization();
    });
    document.addEventListener('page:loaded', normalizeCartTriggers);
    document.addEventListener('shopify:section:load', normalizeCartTriggers);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
